import React from 'react';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
const testimonios = [{
  name: 'Silvia Rodríguez, 47',
  role: 'Profe de Fisicoquímica · La Plata, Bs. As.',
  text: 'Doy 4 cursos de 3° año. Con las fichas dejé de improvisar los lunes. Es el mejor material docente que compré.'
}, {
  name: 'Gustavo Medina, 52',
  role: 'Profe de Física · Córdoba Capital',
  text: 'Lo del error común + corrección es genial: anticipás lo que van a confundir antes de que pase.'
}, {
  name: 'Andrea Quiroga, 38',
  role: 'Profe de Química · Neuquén',
  text: 'Soy suplente y entro a cursos que no conozco. Con el kit llego con la clase armada el mismo día.'
}, {
  name: 'Roberto Vega, 58',
  role: 'Profe de Fisicoquímica · Santa Fe',
  text: 'Después de 30 años dando clase encontré analogías nuevas que a los chicos les cierran enseguida.'
}, {
  name: 'Lucía Benítez, 31',
  role: 'Profe de Fisicoquímica · Salta',
  text: 'Recién recibida, me sentía perdida planificando. El Excel de bimestres me ordenó todo el año.'
}];
export function Testimonios() {
  return <section className="px-4 py-10" aria-labelledby="testi-title" data-id="element-187" data-mp="1s42t1zu7ylpj">
      <h2 id="testi-title" className="text-center font-display text-xl font-extrabold text-white" data-id="element-188" data-mp="1ecehpyrso19m">
        Docentes que ya lo están usando
      </h2>

      <ul className="mt-6 space-y-3" data-id="element-189" data-mp="1j8lccveqpqc9">
        {testimonios.map(t => <li key={t.name} className="rounded-xl border border-teal-300/20 bg-[#0b2b2e]/80 p-3.5 backdrop-blur-sm" data-id="element-190" data-mp="271bn51awq3ky">
            <div className="flex items-center gap-1" data-id="element-191" data-mp="1x2vwt0jpeyci">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-192" data-mp="220xno7ndg1yj" />)}
            </div>
            <p className="mt-2 text-[13.5px] leading-relaxed text-teal-50/90" data-id="element-193" data-mp="qmk3bcrtu4n9">
              “{t.text}”
            </p>
            <p className="mt-2 flex items-center gap-1.5 text-[12px] font-semibold text-white" data-id="element-194" data-mp="6jnz2o6pfsdn">
              {t.name}
              <BadgeCheckIcon className="h-3.5 w-3.5 text-teal-300" aria-hidden="true" data-id="element-195" data-mp="2koy1eo3gfrh" />
            </p>
            <p className="text-[11px] text-teal-200/60" data-id="element-196" data-mp="3oyykvjcdlfq5">{t.role}</p>
          </li>)}
      </ul>
    </section>;
}